import React from 'react';
export function FreelancingPlatforms() {
  return <section id="platforms" className="py-20 px-4 bg-blue-50" data-id="element-103">
      <div className="max-w-6xl mx-auto" data-id="element-104">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-800 mb-16" data-id="element-105">
          Find Me On Freelancing Platforms
        </h2>
        <div className="flex flex-col md:flex-row justify-center items-center gap-8" data-id="element-106">
          <a href="https://www.fiverr.com/s/pdg4Dgo" target="_blank" rel="noopener noreferrer" className="bg-white text-[#1DBF73] border-2 border-[#1DBF73] hover:bg-[#1DBF73] hover:text-white transition-colors rounded-full px-10 py-4 font-bold text-xl inline-flex items-center shadow-md hover:shadow-lg" data-id="element-107">
            Fiverr Profile
          </a>
          <a href="https://www.upwork.com/freelancers/~01a3d2248f07cb3666?mp_source=share" target="_blank" rel="noopener noreferrer" className="bg-white text-[#6FDA44] border-2 border-[#6FDA44] hover:bg-[#6FDA44] hover:text-white transition-colors rounded-full px-10 py-4 font-bold text-xl inline-flex items-center shadow-md hover:shadow-lg" data-id="element-108">
            Upwork Profile
          </a>
        </div>
      </div>
    </section>;
}